var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('base-header',{staticClass:"pb-6"},[_c('div',{staticClass:"row align-items-center py-2"})]),_c('div',{staticClass:"container-fluid mt--6"},[_c('companies')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }